/**
 * TorBadge — "spia" Tor sempre visibile (in ogni schermata, dentro Frame).
 *
 * Tre stati:
 *   🧅 Tor   (verde)  → sei DAVVERO su Tor: modalità Tor attiva E proxy agganciato.
 *   🧅 Tor?  (ambra)  → modalità Tor richiesta ma il proxy NON è agganciato
 *                       (es. Tor caduto in background) → il traffico NON è anonimo.
 *   no Tor   (grigio) → connessione diretta, IP visibile.
 *
 * Tappabile → apre la schermata Tor. Solo nell'app nativa (sul web il Tor si
 * gestisce con Orbot, fuori dal nostro controllo).
 */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNativeApp } from '../lib/platform';
import { torGetStatus, onTorStatus } from '../lib/torNative';
import { TOR_RELAY_FLAG } from '../lib/firebase';

function readWanted() {
  try { return sessionStorage.getItem(TOR_RELAY_FLAG) === '1'; } catch { return false; }
}

export default function TorBadge() {
  const navigate = useNavigate();
  const native = isNativeApp();
  const [on, setOn] = useState(false);          // proxy DAVVERO agganciato
  const [wanted, setWanted] = useState(readWanted()); // modalità Tor richiesta

  useEffect(() => {
    if (!native) return undefined;
    let alive = true;
    let unsub;
    const apply = (s) => { if (alive) setOn(s?.status === 'ON' && !!s?.proxyApplied); };
    const refresh = () => {
      if (!alive) return;
      setWanted(readWanted());
      torGetStatus().then(apply).catch(() => {});
    };
    refresh();
    const id = setInterval(refresh, 4000); // rileva se Tor cade
    onTorStatus(apply).then((u) => { unsub = u; }).catch(() => {});
    return () => { alive = false; clearInterval(id); try { unsub?.(); } catch { /* no-op */ } };
  }, [native]);

  if (!native) return null;

  let label; let cls; let title;
  if (on) {
    label = '🧅 Tor'; cls = 'text-ink border-ink/60 text-glow'; title = 'Sei su Tor: il tuo IP è nascosto';
  } else if (wanted) {
    label = '🧅 Tor?'; cls = 'text-amber border-amber/60'; title = 'Modalità Tor attiva ma NON connesso — il traffico non è anonimo. Tocca per gestire.';
  } else {
    label = 'no Tor'; cls = 'text-ink-dim border-ink-faint'; title = 'Non sei su Tor (connessione diretta). Tocca per attivarlo.';
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/tor')}
      title={title}
      aria-label={title}
      className={`normal-case tracking-normal text-[11px] leading-none px-1.5 py-1 rounded border ${cls} transition-colors`}
    >
      {label}
    </button>
  );
}
